import { render, staticRenderFns } from "./MobileRecovery.vue?vue&type=template&id=24abfa8f"
import script from "./MobileRecovery.vue?vue&type=script&lang=js"
export * from "./MobileRecovery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports